module.exports = __webpack_public_path__ + "img/placeholder.b7bee0a4.jpg";